export const SPONSOR_RELATION_ABSTRACT = 'abstract';
export const SPONSOR_RELATION_ORGANIZATION = 'organization';
